
; require("/srv/www/html/client/modules/vendor/jquery-jqmodal/jquery.jqmodal.js");
; var __browserify_shim_require__=require;(function browserifyShim(module, exports, require, define, browserify_shim__define__module__export__) {

// (function($){$.fn.jqm=function(o){var p={overlay:50,overlayClass:'jqmOverlay',closeClass:'jqmClose',trigger:'.jqModal',ajax:F,ajaxText:'',target:F,modal:F,toTop:F,onShow:F,onHide:F,onLoad:F};return this.each(function(){if(this._jqm)return H[this._jqm].c=$.extend({},H[this._jqm].c,o);s++;this._jqm=s;H[s]={c:$.extend(p,$.jqm.params,o),a:F,w:$(this).addClass('jqmID'+s),s:s};if(p.trigger)$(this).jqmAddTrigger(p.trigger)})};$.fn.jqmAddClose=function(e){return hs(this,e,'jqmHide')};$.fn.jqmAddTrigger=function(e){return hs(this,e,'jqmShow')};$.fn.jqmShow=function(t){return this.each(function(){t=t||window.event;$.jqm.open(this._jqm,t)})};$.fn.jqmHide=function(t){return this.each(function(){t=t||window.event;$.jqm.close(this._jqm,t)})};$.jqm={hash:{},open:function(s,t){var h=H[s],c=h.c,cc='.'+c.closeClass,z=(parseInt(h.w.css('z-index'))),z=(z>0)?z:3000,o=$('<div></div>').css({height:'100%',width:'100%',position:'fixed',left:0,top:0,'z-index':z-1,opacity:c.overlay/100});if(h.a)return F;h.t=t;h.a=true;h.w.css('z-index',z);if(c.modal){if(!A[0])L('bind');A.push(s)}else if(c.overlay>0)h.w.jqmAddClose(o);else o=F;h.o=(o)?o.addClass(c.overlayClass).prependTo('body'):F;if(ie6){$('html,body').css({height:'100%',width:'100%'});if(o){o=o.css({position:'absolute'})[0];for(var y in{Top:1,Left:1})o.style.setExpression(y.toLowerCase(),"(_=(document.documentElement.scroll"+y+" || document.body.scroll"+y+"))+'px'")}}if(c.ajax){var r=c.target||h.w,u=c.ajax,r=(typeof r=='string')?$(r,h.w):$(r),u=(u.substr(0,1)=='@')?$(t).attr(u.substring(1)):u;r.html(c.ajaxText).load(u,function(){if(c.onLoad)c.onLoad.call(this,h);if(cc)h.w.jqmAddClose($(cc,h.w));e(h)})}else if(cc)h.w.jqmAddClose($(cc,h.w));if(c.toTop&&h.o)h.w.before('<span id="jqmP'+h.w[0]._jqm+'"></span>').insertAfter(h.o);(c.onShow)?c.onShow(h):h.w.show();e(h);return F},close:function(s){var h=H[s];if(!h.a)return F;h.a=F;if(A[0]){A.pop();if(!A[0])L('unbind')}if(h.c.toTop&&h.o)$('#jqmP'+h.w[0]._jqm).after(h.w).remove();if(h.c.onHide)h.c.onHide(h);else{h.w.hide();if(h.o)h.o.remove()}return F},params:{}};var s=0,H=$.jqm.hash,A=[],ie6=$.browser.msie&&($.browser.version=="6.0"),F=false,i=$('<iframe src="javascript:false;document.write(\'\');" class="jqm"></iframe>').css({opacity:0}),e=function(h){if(ie6)if(h.o)h.o.html('<p style="width:100%;height:100%"/>').prepend(i);else if(!$('iframe.jqm',h.w)[0])h.w.prepend(i);f(h)},f=function(h){try{$(':input:visible',h.w)[0].focus()}catch(_){}},L=function(t){$()[t]("keypress",m)[t]("keydown",m)[t]("mousedown",m)},m=function(e){var h=H[A[A.length-1]],r=(!$(e.target).parents('.jqmID'+h.s)[0]);if(r)f(h);return!r},hs=function(w,t,c){return w.each(function(){var s=this._jqm;$(t).each(function(){if(!this[c]){this[c]=[];$(this).click(function(){for(var i in{jqmShow:1,jqmHide:1})for(var s in this[i])if(H[this[i][s]])H[this[i][s]].w[i](this);return F})}this[c].push(s)})})}})(jQuery);
window.modal = {};

modal.open = function(use) {

	console.log("modal open called");

	var self = this;

	var options = {
		width: 500,
		height: 300,
		top: 200,
		left: '50%',
		modal: true,
		closeBtn: true,
		loading: true,
		opened: null,
		iframe: false,
		modalClass: ""
	};

	$('.jqm-close-container').hide();

	if (arguments.length > 1) {
		$.extend(options, arguments[1]);
	}

	if (options.closeBtn) {
		$('.jqm-close-container').show();
	}

	self.$modal = $('#modal').addClass(options.modalClass);
	self.$content = $('#modalContent');

	/*self.$modal.css({
		'width': options.width,
		'top': options.top,
		'left': options.left
	});*/

	//'height': options.height,

	// self.$modal.css('margin-left', '-' + (self.$modal.outerWidth() / 2) + 'px');

	if (options.loading) {
		self.$content.html('<img src="/controlpanel/store/images/16x16.gif" style="margin: 0 4px 3px 0; vertical-align: middle;" /> Loading...');
	}

	if(options.iframe){
		self.$content.html("<iframe src=' " + use + "' height='" + options.height + "' width='" + options.width + "'>");
	}

	self.$modal.jqm({
		modal: options.modal,
		overlay: 70,
		toTop: true,
		onHide: function(hash) {

			$(document).trigger({
				type: "jqm_modal_closed"
			});

			hash.w.hide();
			hash.o.remove();

		}
	}).jqmShow();

	// don't fill with content on load
	if (use == '') {
		return false;
	}

	if (use.search(/#/) === -1) {

		// ajax call to load it with content
		$.ajax({
			cache: false,
			type: 'get',
			url: use,
			dataType: 'html',
			success: function(data) {

				if (typeof options.opened === 'function') {
					options.opened.call();
				} else {
					self.$content.html(data);
				}

			}
		});

	} else {
		self.$content.html($(use).html());
	}

	return false;

};

/**
 *	update the content inside the modal
 */
modal.html = function(html) {

	console.log("modal html called");

	var self = this;

	self.$content.html(html);

};

/**
 *	closes the modal
 */
modal.close = function() {

	console.log("modal close called");

	var self = this;

	self.$modal.jqmHide();

	// $("#modal").remove();

	return false;

};

/**
 *	animated resizing
 */
modal.resize = function(width, height) {

	var self = this;

	$('div.jqm-close-container').hide();

	self.$modal.animate({
		width: width,
		height: height,
    	marginLeft: '-' + ((width + parseInt(self.$modal.css('padding-left')) + parseInt(self.$modal.css('border-left-width'))) / 2) + 'px'
  	}, 500, function() {
  		$('div.jqm-close-container').show();
		});

};

// this extra code prevents "double playback in chrome"
// i.e. starting the video over upon closing the modal
$(document).on("jqm_modal_closed", function(){

	var $modal = $("#modal");

	$modal.find("iframe").remove();

});
; browserify_shim__define__module__export__(typeof modal != "undefined" ? modal : window.modal);

}).call(global, undefined, undefined, undefined, undefined, function defineExport(ex) { module.exports = ex; });
